"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get COMMON_DELETE_ROLES () {
        return COMMON_DELETE_ROLES;
    },
    get COMMON_DELETE_ROLES_SET () {
        return COMMON_DELETE_ROLES_SET;
    },
    get CREATOR_AND_UP () {
        return CREATOR_AND_UP;
    },
    get CREATOR_AND_UP_SET () {
        return CREATOR_AND_UP_SET;
    },
    get EXTERNAL_ROLES () {
        return EXTERNAL_ROLES;
    },
    get EXTERNAL_ROLES_SET () {
        return EXTERNAL_ROLES_SET;
    },
    get GUEST () {
        return GUEST;
    },
    get INTERNAL_ROLES () {
        return INTERNAL_ROLES;
    },
    get INTERNAL_ROLES_SET () {
        return INTERNAL_ROLES_SET;
    },
    get Policies () {
        return Policies;
    },
    get RESOURCE_NAME () {
        return RESOURCE_NAME;
    },
    get RoleNames () {
        return RoleNames;
    },
    get UserRoleNames () {
        return UserRoleNames;
    },
    get resourcePermissionRequiresPII () {
        return resourcePermissionRequiresPII;
    }
});
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const UserRoleNames = [
    "manager",
    "member",
    "creator",
    "view_only"
];
const RoleNames = [
    ...UserRoleNames,
    "admin",
    "guest",
    "publicUser"
];
const GUEST = [
    "guest"
];
const EXTERNAL_ROLES = [
    "guest",
    "publicUser"
];
const EXTERNAL_ROLES_SET = new Set(EXTERNAL_ROLES);
const INTERNAL_ROLES = [
    "view_only",
    "creator",
    "member",
    "manager",
    "admin"
];
const INTERNAL_ROLES_SET = new Set(INTERNAL_ROLES);
const CREATOR_AND_UP = [
    "creator",
    "member",
    "manager",
    "admin"
];
const CREATOR_AND_UP_SET = new Set(CREATOR_AND_UP);
const COMMON_DELETE_ROLES = [
    "member",
    "manager",
    "admin"
];
const COMMON_DELETE_ROLES_SET = new Set(COMMON_DELETE_ROLES);
var RESOURCE_NAME = /*#__PURE__*/ function(RESOURCE_NAME) {
    RESOURCE_NAME["ACCOUNT"] = "account";
    RESOURCE_NAME["ACCOUNT_CONTACT_INFORMATION"] = "accountContactInformation";
    RESOURCE_NAME["ACCOUNT_PROPERTY_WARNING"] = "accountPropertyWarning";
    RESOURCE_NAME["ACTIVITY"] = "activity";
    RESOURCE_NAME["ADMIN"] = "admin";
    RESOURCE_NAME["AI_ACTION"] = "aiAction";
    RESOURCE_NAME["AI_ACTION_RUN_RESULT"] = "aiActionRun";
    RESOURCE_NAME["AI_FEEDBACK"] = "aiFeedback";
    RESOURCE_NAME["API_KEY"] = "apiKey";
    RESOURCE_NAME["APP"] = "app";
    RESOURCE_NAME["ARCGIS_EXPORT_CONFIGURATION"] = "arcGISExportConfiguration";
    RESOURCE_NAME["BASE_MAP"] = "baseMap";
    RESOURCE_NAME["BULK_ACTION"] = "bulkAction";
    RESOURCE_NAME["CERTIFICATE"] = "certificate";
    RESOURCE_NAME["CERTIFICATE_UPLOAD"] = "certificateUpload";
    RESOURCE_NAME["CERTIFICATE_ERROR"] = "certificateError";
    RESOURCE_NAME["COMMENT"] = "comment";
    RESOURCE_NAME["CUSTOM_MAP"] = "customMap";
    RESOURCE_NAME["CUSTOM_MAP_GEOMETRY"] = "customMapGeometry";
    RESOURCE_NAME["CUSTOM_OBJECT_GROUP"] = "customObjectGroup";
    RESOURCE_NAME["DESIGN_FLOOD_ELEVATION"] = "designFloodElevation";
    RESOURCE_NAME["DOCUMENT_TEMPLATE"] = "documentTemplate";
    RESOURCE_NAME["DOCUMENT_UPLOAD"] = "documentUpload";
    RESOURCE_NAME["FEATURE_FLAG"] = "featureFlag";
    RESOURCE_NAME["FEATURED_CONTENT"] = "featuredContent";
    RESOURCE_NAME["FIRM"] = "firm";
    RESOURCE_NAME["GENERATED_DOCUMENT"] = "generatedDocument";
    RESOURCE_NAME["USER_GROUP"] = "userGroup";
    RESOURCE_NAME["HEALTH_CHECK"] = "healthCheck";
    RESOURCE_NAME["HELPSCOUT_BEACON"] = "helpscoutBeacon";
    RESOURCE_NAME["INFORMATION_REQUEST"] = "informationRequest";
    RESOURCE_NAME["IMPROVEMENT"] = "improvement";
    RESOURCE_NAME["ISSUE"] = "issue";
    RESOURCE_NAME["DATA_SETTINGS"] = "dataSettings";
    RESOURCE_NAME["MAILING"] = "mailing";
    RESOURCE_NAME["OFFLINE_PACK"] = "offlinePack";
    RESOURCE_NAME["PARCEL"] = "parcel";
    RESOURCE_NAME["PARCEL_IMPORT_TASK"] = "parcelImportTask";
    RESOURCE_NAME["PARCEL_IMPORT_CONFIGURATION"] = "parcelImportConfiguration";
    RESOURCE_NAME["PASSWORD_RESET"] = "passwordReset";
    RESOURCE_NAME["PERMIT"] = "permit";
    RESOURCE_NAME["PROPERTY"] = "property";
    RESOURCE_NAME["PROPERTY_ATTRIBUTE"] = "propertyAttribute";
    RESOURCE_NAME["PUBLIC_ACCOUNT_PORTAL"] = "publicAccountPortal";
    RESOURCE_NAME["PUBLIC_USER"] = "publicUser";
    RESOURCE_NAME["RASTER"] = "raster";
    RESOURCE_NAME["REPETITIVE_LOSS"] = "repetitiveLoss";
    RESOURCE_NAME["REPETITIVE_LOSS_IMPORT_JOB"] = "repetitiveLossImportJob";
    RESOURCE_NAME["ROOT"] = "root";
    RESOURCE_NAME["RULE_DEFINITION"] = "ruleDefinition";
    RESOURCE_NAME["SAVED_VIEW"] = "savedView";
    RESOURCE_NAME["SEARCH"] = "search";
    RESOURCE_NAME["SECURITY_CONFIGURATION"] = "securityConfiguration";
    RESOURCE_NAME["SCRIPT_JOB"] = "scriptJob";
    RESOURCE_NAME["SUBMISSION"] = "submission";
    RESOURCE_NAME["SUBMISSION_TYPE"] = "submissionType";
    RESOURCE_NAME["SUBMISSION_SUMMARY"] = "submissionSummary";
    RESOURCE_NAME["TASK"] = "task";
    RESOURCE_NAME["THIRD_PARTY_SYSTEM_CONFIGURATION"] = "thirdPartySystemConfiguration";
    RESOURCE_NAME["TRANSCRIPTION_TASK"] = "transcriptionTask";
    RESOURCE_NAME["USER"] = "user";
    RESOURCE_NAME["USER_INVITE"] = "userInvite";
    RESOURCE_NAME["PAGINATION_INFO"] = "paginationInfo";
    RESOURCE_NAME["PUBLIC_USER_INVITE"] = "publicUserInvite";
    RESOURCE_NAME["WARNING"] = "warning";
    RESOURCE_NAME["MOBILE_VERSION"] = "mobileVersion";
    RESOURCE_NAME["USER_DEVICE"] = "userDevice";
    RESOURCE_NAME["USER_DEVICE_LOCATION"] = "userDeviceLocation";
    RESOURCE_NAME["QUERY_DESCRIPTION"] = "queryDescription";
    RESOURCE_NAME["WORKFLOW"] = "workflow";
    RESOURCE_NAME["WORKFLOW_STEP"] = "workflowStep";
    RESOURCE_NAME["WORKFLOW_DEFINITION"] = "workflowDefinition";
    return RESOURCE_NAME;
}({});
const Policies = {
    ["account"]: {
        find: new Set([
            "*"
        ]),
        view: {
            guest: new Set([
                "id",
                "name",
                "state",
                "bounds",
                "freeboard",
                "projectTracking",
                "cumulativeTrackingPeriod",
                "projectThresholdPercentage",
                "propertyAdjustmentRatio",
                "firms",
                "datums",
                "coastalADetermination",
                "dfeDeterminationMethod",
                "featureFlags",
                "crsEnabled",
                "ecErrorDetectionEnabled",
                "ecErrorDetectionStartDate",
                "repetitiveLossEnabled",
                "baseMaps",
                "isPilot",
                "contactInformation",
                "publicPortal",
                "accountDocumentTypes",
                "logoUrl",
                "parcelFieldNameOverrides",
                "securityConfiguration",
                "disclaimerOverrides",
                "subdomain",
                "logoUrl",
                "userGroups",
                "isSSOEnabled",
                "ssoProviders"
            ]),
            publicUser: new Set([
                "id",
                "name",
                "state",
                "bounds",
                "freeboard",
                "projectTracking",
                "cumulativeTrackingPeriod",
                "projectThresholdPercentage",
                "propertyAdjustmentRatio",
                "firms",
                "datums",
                "coastalADetermination",
                "dfeDeterminationMethod",
                "featureFlags",
                "crsEnabled",
                "ecErrorDetectionEnabled",
                "ecErrorDetectionStartDate",
                "repetitiveLossEnabled",
                "baseMaps",
                "isPilot",
                "contactInformation",
                "publicPortal",
                "accountDocumentTypes",
                "logoUrl",
                "parcelFieldNameOverrides",
                "securityConfiguration",
                "disclaimerOverrides",
                "subdomain",
                "logoUrl",
                "userGroups",
                "isSSOEnabled",
                "ssoProviders"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        list: new Set([
            "admin"
        ]),
        update: new Set([
            "manager",
            "admin"
        ]),
        updateDisclaimerOverrides: new Set([
            "admin"
        ]),
        create: new Set([
            "admin"
        ]),
        updateSupportedLanguages: new Set([
            "manager",
            "admin"
        ])
    },
    ["accountContactInformation"]: {
        view: new Set([
            "*"
        ])
    },
    ["accountPropertyWarning"]: {
        create: new Set([
            "creator",
            "manager",
            "admin"
        ]),
        update: new Set([
            "creator",
            "manager",
            "admin"
        ]),
        delete: new Set([
            "creator",
            "manager",
            "admin"
        ])
    },
    ["activity"]: {
        view: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        list: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        export: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ])
    },
    ["admin"]: {
        find: new Set([
            "*"
        ]),
        login: new Set([
            "*"
        ]),
        view: {
            admin: new Set([
                "*"
            ]),
            view_only: new Set([
                "firstName",
                "lastName",
                "id"
            ]),
            creator: new Set([
                "firstName",
                "lastName",
                "id"
            ]),
            member: new Set([
                "firstName",
                "lastName",
                "id"
            ]),
            manager: new Set([
                "firstName",
                "lastName",
                "id"
            ])
        }
    },
    ["app"]: {
        view: new Set([
            "*"
        ])
    },
    ["arcGISExportConfiguration"]: {
        view: new Set([
            "admin"
        ]),
        create: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ])
    },
    ["baseMap"]: {
        view: new Set([
            "*"
        ]),
        list: new Set([
            "*"
        ]),
        create: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ])
    },
    ["bulkAction"]: {
        view: INTERNAL_ROLES_SET,
        dispatch: CREATOR_AND_UP_SET
    },
    ["certificate"]: {
        find: new Set([
            "*"
        ]),
        view: {
            guest: new Set([
                "id",
                "issuedAt",
                "documentUpload",
                "type",
                "property",
                "certificateUpload",
                "address",
                "elevationDatum",
                "nfipCountyName",
                "nfipState",
                "benchmarkUtilized",
                "buildingUse",
                "buildingDiagramNumber",
                "crawlspaceSqft",
                "numCrawlspaceFloodOpenings",
                "netAreaOfCrawlspaceFloodOpenings",
                "engineeredCrawlspaceFloodOpenings",
                "garageSqft",
                "numGarageFloodOpenings",
                "netAreaOfGarageFloodOpenings",
                "engineeredGarageFloodOpenings",
                "firmIndexDate",
                "firmPanelEffectiveDate",
                "floodZone",
                "baseFloodElevation",
                "baseFloodElevationDatum",
                "baseFloodElevationDatumOther",
                "fiveHundredYearFloodElevation",
                "comments",
                "coordinatesProvidedBySurveyor",
                "conversionFactorUsed",
                "buildingElevationSource",
                "propertyDescription",
                "topOfBottomFloor",
                "topOfNextHigherFloor",
                "bottomOfLowestHorizontalStructuralMember",
                "attachedGarage",
                "lowestElevationOfMachineryOrEquipment",
                "lowestAdjacentGrade",
                "lowestAdjacentGradeType",
                "highestAdjacentGrade",
                "highestAdjacentGradeType",
                "lowestAdjacentGradeAtLowestElevationOfDeckOrStairs",
                "buildingElevationInfo",
                "lowestFloorElevationField",
                "buildingElevations",
                "validationErrors",
                "streetAddress",
                "state",
                "city",
                "zipcode",
                "certifierName",
                "certifierLicenseNumber",
                "certifierInfo",
                "propertyOwnerInfo",
                "firmMapNumber",
                "hiddenFromPublic",
                "formYear",
                "regulatoryLowestFloorElevation",
                "nfipLowestFloorElevation",
                "regulatoryLowestFloorElevationDetails",
                "nfipLowestFloorElevationDetails",
                "attachedGarageInfo",
                "crawlspaceInfo",
                "sqft",
                "netAreaOfFloodOpenings",
                "numFloodOpenings",
                "engineeredFloodOpenings",
                "oneFloodOpeningTwoSides",
                "numNonEngineeredOpenings",
                "numEngineeredOpenings",
                "netAreaNonEngineeredOpenings",
                "ratedAreaOfEngineeredOpenings",
                "telephone",
                "email",
                "licenseNumber",
                "name",
                "sealPresent",
                "signaturePresent",
                "permit",
                "communityInfo",
                "buildingMeasurementInfo",
                "finishedConstruction",
                "extractedData",
                "firmSuffix",
                "nfipCommunityNumber",
                "nfipCommunityName",
                "elevationDatumComments",
                "verticalDatum",
                "buildingLocatedSeawardOfLimwa",
                "buildingLocatedInCbrsOrOpa",
                "buildingLocatedInCbrsOrOpaDesignationDate",
                "isBuildingLocatedInCbrsOrOpa",
                "baseFloodElevationSource",
                "longitude",
                "latitude",
                "horizontalDatum",
                "errorDetectionEligibility",
                "buildingOwnerName",
                "measurementsBasedOn",
                "topOfBottomFloorElevatedPerOrdinance",
                "offsets",
                "sectionCTakenFromOtherAuthorizedSource",
                "sectionECompletedByLocalOfficial",
                "sectionHCompletedByLocalOfficial",
                "sectionGCommentsProvidedByLocalOfficial",
                "communityInfoProvidedForFloodplainManagementPurposes",
                "permitNumber",
                "permitDateIssued",
                "certificateOfComplianceOrOccupancyDateIssued",
                "permitIssuedForNewConstructionOrSI",
                "elevations",
                "varianceIssued",
                "localOfficialInfo",
                "firms",
                "pageHeaderAddressesAreConsistent",
                "everyPageHasHeaderAddress",
                "numberOfPhotosProvided",
                "elevationDatumOther",
                "everyPhotoIsInColor",
                "date"
            ]),
            publicUser: new Set([
                "id",
                "issuedAt",
                "documentUpload",
                "type",
                "property",
                "certificateUpload",
                "address",
                "elevationDatum",
                "nfipCountyName",
                "nfipState",
                "benchmarkUtilized",
                "buildingUse",
                "buildingDiagramNumber",
                "crawlspaceSqft",
                "numCrawlspaceFloodOpenings",
                "netAreaOfCrawlspaceFloodOpenings",
                "engineeredCrawlspaceFloodOpenings",
                "garageSqft",
                "numGarageFloodOpenings",
                "netAreaOfGarageFloodOpenings",
                "engineeredGarageFloodOpenings",
                "firmIndexDate",
                "firmPanelEffectiveDate",
                "floodZone",
                "baseFloodElevation",
                "baseFloodElevationDatum",
                "baseFloodElevationDatumOther",
                "fiveHundredYearFloodElevation",
                "comments",
                "coordinatesProvidedBySurveyor",
                "conversionFactorUsed",
                "buildingElevationSource",
                "propertyDescription",
                "topOfBottomFloor",
                "topOfNextHigherFloor",
                "bottomOfLowestHorizontalStructuralMember",
                "attachedGarage",
                "lowestElevationOfMachineryOrEquipment",
                "lowestAdjacentGrade",
                "lowestAdjacentGradeType",
                "highestAdjacentGrade",
                "highestAdjacentGradeType",
                "lowestAdjacentGradeAtLowestElevationOfDeckOrStairs",
                "buildingElevationInfo",
                "lowestFloorElevationField",
                "buildingElevations",
                "validationErrors",
                "streetAddress",
                "state",
                "city",
                "zipcode",
                "certifierName",
                "certifierLicenseNumber",
                "certifierInfo",
                "propertyOwnerInfo",
                "firmMapNumber",
                "hiddenFromPublic",
                "formYear",
                "regulatoryLowestFloorElevation",
                "nfipLowestFloorElevation",
                "regulatoryLowestFloorElevationDetails",
                "nfipLowestFloorElevationDetails",
                "attachedGarageInfo",
                "crawlspaceInfo",
                "sqft",
                "netAreaOfFloodOpenings",
                "numFloodOpenings",
                "engineeredFloodOpenings",
                "oneFloodOpeningTwoSides",
                "numNonEngineeredOpenings",
                "numEngineeredOpenings",
                "netAreaNonEngineeredOpenings",
                "ratedAreaOfEngineeredOpenings",
                "telephone",
                "email",
                "licenseNumber",
                "name",
                "sealPresent",
                "signaturePresent",
                "permit",
                "communityInfo",
                "buildingMeasurementInfo",
                "finishedConstruction",
                "extractedData",
                "firmSuffix",
                "nfipCommunityNumber",
                "nfipCommunityName",
                "elevationDatumComments",
                "verticalDatum",
                "buildingLocatedSeawardOfLimwa",
                "buildingLocatedInCbrsOrOpa",
                "buildingLocatedInCbrsOrOpaDesignationDate",
                "isBuildingLocatedInCbrsOrOpa",
                "baseFloodElevationSource",
                "longitude",
                "latitude",
                "horizontalDatum",
                "errorDetectionEligibility",
                "buildingOwnerName",
                "measurementsBasedOn",
                "topOfBottomFloorElevatedPerOrdinance",
                "offsets",
                "sectionCTakenFromOtherAuthorizedSource",
                "sectionECompletedByLocalOfficial",
                "sectionHCompletedByLocalOfficial",
                "sectionGCommentsProvidedByLocalOfficial",
                "communityInfoProvidedForFloodplainManagementPurposes",
                "permitNumber",
                "permitDateIssued",
                "certificateOfComplianceOrOccupancyDateIssued",
                "permitIssuedForNewConstructionOrSI",
                "elevations",
                "varianceIssued",
                "localOfficialInfo",
                "firms",
                "pageHeaderAddressesAreConsistent",
                "everyPageHasHeaderAddress",
                "numberOfPhotosProvided",
                "elevationDatumOther",
                "everyPhotoIsInColor",
                "date"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        hide: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        export: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        updateSettings: new Set([
            "admin"
        ]),
        update: new Set([
            "member",
            "manager",
            "admin"
        ])
    },
    ["certificateError"]: {
        view: {
            guest: new Set([
                "data",
                "count",
                "id",
                "errorCode",
                "issue",
                "type",
                "value",
                "field",
                "note",
                "valueAttr",
                "ignored"
            ]),
            publicUser: new Set([
                "data",
                "count",
                "id",
                "errorCode",
                "issue",
                "type",
                "value",
                "field",
                "note",
                "valueAttr",
                "ignored"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        update: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        generateSummary: new Set([
            "creator",
            "member",
            "manager",
            "admin",
            "view_only"
        ])
    },
    ["certificateUpload"]: {
        view: {
            guest: new Set([
                "id",
                "status"
            ]),
            publicUser: new Set([
                "id",
                "status"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        bulk_create: new Set([
            "admin"
        ]),
        cancel: new Set([
            "admin"
        ]),
        update: new Set([
            "member",
            "manager",
            "admin"
        ])
    },
    ["comment"]: {
        view: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        create: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        delete: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        list: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ])
    },
    ["customMap"]: {
        view: {
            guest: new Set([
                "customMaps",
                "id",
                "name",
                "labelsVisibleOnMap",
                "isDefault",
                "isObject",
                "searchEnabled",
                "legend",
                "type",
                "tileset",
                "sources",
                "config",
                "geometries",
                "allowsCreation",
                "defaultStyles"
            ]),
            publicUser: new Set([
                "customMaps",
                "id",
                "name",
                "labelsVisibleOnMap",
                "isDefault",
                "isObject",
                "searchEnabled",
                "legend",
                "type",
                "tileset",
                "sources",
                "config",
                "geometries",
                "allowsCreation",
                "defaultStyles"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        viewIntersections: new Set([
            "guest",
            "publicUser",
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        viewGeometryCount: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        create: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ])
    },
    ["customMapGeometry"]: {
        view: {
            guest: new Set([
                "customMapGeometry",
                "customMap",
                "documentUploads",
                "id",
                "label",
                "sourceId",
                "bounds",
                "interiorPoint",
                "additionalFields",
                "customMapId",
                "coverImageDocumentUploadId"
            ]),
            publicUser: new Set([
                "customMapGeometry",
                "customMap",
                "documentUploads",
                "id",
                "label",
                "sourceId",
                "bounds",
                "interiorPoint",
                "additionalFields",
                "customMapId",
                "coverImageDocumentUploadId"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        create: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        update: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        share: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ])
    },
    ["customObjectGroup"]: {
        view: new Set([
            "*"
        ]),
        create: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ])
    },
    ["designFloodElevation"]: {
        list: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        view: new Set([
            "*"
        ]),
        update: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ])
    },
    ["documentTemplate"]: {
        create: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ]),
        list: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        view: {
            view_only: new Set([
                "id",
                "name",
                "accountDocumentType",
                "customMapId",
                "submissionTypeId",
                "documentUploadFormDataPath"
            ]),
            creator: new Set([
                "id",
                "name",
                "accountDocumentType",
                "customMapId",
                "submissionTypeId",
                "documentUploadFormDataPath"
            ]),
            member: new Set([
                "id",
                "name",
                "accountDocumentType",
                "customMapId",
                "submissionTypeId",
                "documentUploadFormDataPath"
            ]),
            manager: new Set([
                "id",
                "name",
                "accountDocumentType",
                "customMapId",
                "submissionTypeId",
                "documentUploadFormDataPath"
            ]),
            admin: new Set([
                "*"
            ])
        }
    },
    ["documentUpload"]: {
        list: new Set([
            "*"
        ]),
        table: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        view: {
            guest: new Set([
                "id",
                "name",
                "originalFilename",
                "mimeType",
                "url",
                "documentType",
                "issuedAt",
                "createdAt",
                "elevationCertificate",
                "accountDocumentType",
                "formData",
                "property",
                "documentUpload",
                "hiddenFromPublic",
                "certificateUpload",
                "isDeletable",
                "customMapGeometry",
                "objectType",
                "objectId",
                "hasAssociatedAIActionRun",
                "externalDocumentURL"
            ]),
            publicUser: new Set([
                "id",
                "name",
                "originalFilename",
                "mimeType",
                "url",
                "documentType",
                "issuedAt",
                "createdAt",
                "elevationCertificate",
                "accountDocumentType",
                "formData",
                "property",
                "documentUpload",
                "hiddenFromPublic",
                "certificateUpload",
                "isDeletable",
                "customMapGeometry",
                "objectType",
                "objectId",
                "hasAssociatedAIActionRun",
                "externalDocumentURL"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        view_details: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        create: new Set([
            "guest",
            "publicUser",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        delete: new Set([
            "member",
            "manager",
            "admin"
        ]),
        hide: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        update: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        share: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ])
    },
    ["featureFlag"]: {
        view: new Set([
            "guest",
            "publicUser",
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        update: new Set([
            "admin"
        ])
    },
    ["featuredContent"]: {
        view: new Set([
            "*"
        ])
    },
    ["firm"]: {
        create: new Set([
            "admin"
        ]),
        view: new Set([
            "*"
        ]),
        update: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        view_settings: new Set([
            "admin"
        ]),
        import: new Set([
            "admin"
        ])
    },
    ["generatedDocument"]: {
        create: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        update: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ])
    },
    ["userGroup"]: {
        list: new Set([
            "*"
        ]),
        view: new Set([
            "*"
        ]),
        create: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ])
    },
    ["healthCheck"]: {
        view: new Set([
            "*"
        ])
    },
    ["helpscoutBeacon"]: {
        view: new Set([
            "*"
        ]),
        update: new Set([
            "admin"
        ])
    },
    ["informationRequest"]: {
        find: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        list: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        view: {
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        public_create: new Set([
            "*"
        ]),
        private_create: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        update: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        export: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        delete: new Set([
            "member",
            "manager",
            "admin"
        ])
    },
    ["improvement"]: {
        view: {
            guest: new Set([
                "id",
                "progress",
                "description",
                "exclusion",
                "date",
                "value",
                "kind",
                "hiddenFromPublic"
            ]),
            publicUser: new Set([
                "id",
                "progress",
                "description",
                "exclusion",
                "date",
                "value",
                "kind",
                "hiddenFromPublic"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        }
    },
    ["thirdPartySystemConfiguration"]: {
        create: new Set([
            "admin"
        ]),
        view: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ])
    },
    ["dataSettings"]: {
        create: new Set([
            "admin"
        ]),
        list: new Set([
            "admin"
        ]),
        view: new Set([
            "admin"
        ]),
        upload: new Set([
            "admin"
        ])
    },
    ["offlinePack"]: {
        list: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        create: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        update: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        delete: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ])
    },
    ["parcel"]: {
        find: new Set([
            "*"
        ]),
        view: {
            guest: new Set([
                "id",
                "lot",
                "block",
                "parcelId",
                "yearBuilt",
                "parcelId",
                "parcelValue",
                "landValue",
                "improvementValue",
                "buildingDescription",
                "owner",
                "legalDescription",
                "mailingAddress1",
                "mailingAddress2",
                "address",
                "additionalFields"
            ]),
            publicUser: new Set([
                "id",
                "lot",
                "block",
                "parcelId",
                "yearBuilt",
                "parcelId",
                "parcelValue",
                "landValue",
                "improvementValue",
                "buildingDescription",
                "owner",
                "legalDescription",
                "mailingAddress1",
                "mailingAddress2",
                "address",
                "additionalFields"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        }
    },
    ["parcelImportTask"]: {
        create: new Set([
            "admin"
        ]),
        list: new Set([
            "admin"
        ]),
        view: new Set([
            "admin"
        ]),
        upload: new Set([
            "admin"
        ])
    },
    ["passwordReset"]: {
        view: new Set([
            "*"
        ])
    },
    ["parcelImportConfiguration"]: {
        view: INTERNAL_ROLES_SET,
        create: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ])
    },
    ["permit"]: {
        view: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        update: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ])
    },
    ["property"]: {
        find: new Set([
            "*"
        ]),
        list: new Set([
            "*"
        ]),
        view: {
            guest: new Set([
                "id",
                "latitude",
                "longitude",
                "parcelId",
                "fullAddress",
                "streetAddress",
                "city",
                "state",
                "zipcode",
                "parcelDataRevisedDate",
                "coordinates",
                "standardizedAddress",
                "certificates",
                "description",
                "lot",
                "block",
                "documentUploads",
                "parcel",
                "improvementValue",
                "landValue",
                "parcelValue",
                "additionalFields",
                "streetViewEnabled",
                "coverImageDocumentUploadId",
                "firms",
                "hiddenFromPublic"
            ]),
            publicUser: new Set([
                "id",
                "latitude",
                "longitude",
                "parcelId",
                "fullAddress",
                "streetAddress",
                "city",
                "state",
                "zipcode",
                "parcelDataRevisedDate",
                "coordinates",
                "standardizedAddress",
                "certificates",
                "description",
                "lot",
                "block",
                "documentUploads",
                "parcel",
                "improvementValue",
                "landValue",
                "parcelValue",
                "additionalFields",
                "streetViewEnabled",
                "coverImageDocumentUploadId",
                "firms",
                "hiddenFromPublic"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        view_sisd: new Set([
            "*"
        ]),
        create: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        update: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        share: new Set([
            "creator",
            "member",
            "manager",
            "admin",
            "view_only"
        ]),
        merge: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin",
            "manager",
            "member"
        ]),
        hide: new Set([
            "admin",
            "manager",
            "member"
        ])
    },
    ["propertyAttribute"]: {
        create: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        view: new Set([
            "*"
        ])
    },
    ["publicAccountPortal"]: {
        view: new Set([
            "*"
        ])
    },
    ["publicUser"]: {
        login: new Set([
            "*"
        ]),
        view: {
            guest: new Set([
                "id",
                "firstName",
                "lastName",
                "phone",
                "account"
            ]),
            publicUser: new Set([
                "*"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        update: new Set([
            "view_only",
            "member",
            "creator",
            "manager",
            "admin"
        ]),
        list: new Set([
            "admin",
            "manager"
        ]),
        impersonate: new Set([
            "admin"
        ]),
        updateUserPermissions: new Set([
            "admin",
            "manager"
        ]),
        export: new Set([
            "admin",
            "manager"
        ]),
        signup: new Set([
            "guest"
        ]),
        emailConfirmation: new Set([
            "*"
        ]),
        manageStatus: CREATOR_AND_UP_SET
    },
    ["raster"]: {
        view: new Set([
            "*"
        ]),
        create: new Set([
            "admin"
        ])
    },
    ["repetitiveLoss"]: {
        view: new Set([
            "admin",
            "manager",
            "member",
            "creator",
            "view_only"
        ]),
        view_settings: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        list: new Set([
            "admin"
        ]),
        export: new Set([
            "admin"
        ])
    },
    ["repetitiveLossImportJob"]: {
        import: new Set([
            "admin"
        ]),
        list: new Set([
            "admin"
        ]),
        upload: new Set([
            "admin"
        ])
    },
    ["root"]: {
        view: new Set([
            "admin"
        ])
    },
    ["ruleDefinition"]: {
        create: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        view: new Set([
            "*"
        ])
    },
    // Note - If we expose saved view to public, we'll need to
    // ensure the tiles endpoints apply hiddenFromPublic as needed
    ["savedView"]: {
        find: INTERNAL_ROLES_SET,
        view: new Set([
            "*"
        ]),
        list: new Set([
            "*"
        ]),
        queryAllData: INTERNAL_ROLES_SET,
        queryLockedDownData: new Set([
            "*"
        ]),
        create: CREATOR_AND_UP_SET,
        delete: CREATOR_AND_UP_SET,
        update: CREATOR_AND_UP_SET,
        updateVisibility: new Set([
            "admin",
            "manager"
        ]),
        export: INTERNAL_ROLES_SET
    },
    ["search"]: {
        view: new Set([
            "*"
        ])
    },
    ["securityConfiguration"]: {
        view: {
            guest: new Set([
                "id",
                "minimumPasswordLength",
                "multifactorAuthEnabled"
            ]),
            publicUser: new Set([
                "id",
                "minimumPasswordLength",
                "multifactorAuthEnabled",
                "sessionTimeoutMinutes"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        }
    },
    ["scriptJob"]: {
        view: new Set([
            "admin"
        ]),
        list: new Set([
            "admin"
        ]),
        dispatch: new Set([
            "admin"
        ]),
        upload: new Set([
            "admin",
            "manager",
            "member",
            "creator",
            "view_only"
        ])
    },
    ["submission"]: {
        view: new Set([
            "*"
        ]),
        list: new Set([
            "admin",
            "manager",
            "member",
            "creator",
            "view_only"
        ]),
        update: new Set([
            "admin",
            "manager",
            "member",
            "creator"
        ]),
        delete: new Set([
            "admin",
            "manager",
            "member"
        ]),
        updateVisibility: new Set([
            "admin",
            "manager",
            "member"
        ]),
        export: new Set([
            "admin",
            "manager",
            "member",
            "creator"
        ]),
        table: new Set([
            "admin",
            "manager",
            "member",
            "creator",
            "view_only"
        ])
    },
    ["submissionType"]: {
        create: new Set([
            "admin",
            "manager"
        ]),
        update: new Set([
            "admin",
            "manager"
        ]),
        view: new Set([
            "*"
        ]),
        delete: new Set([
            "admin",
            "manager"
        ])
    },
    ["submissionSummary"]: {
        list: new Set([
            "*"
        ]),
        view: new Set([
            "*"
        ])
    },
    ["task"]: {
        view: INTERNAL_ROLES_SET,
        create: CREATOR_AND_UP_SET,
        update: CREATOR_AND_UP_SET,
        list: INTERNAL_ROLES_SET,
        delete: CREATOR_AND_UP_SET
    },
    ["transcriptionTask"]: {
        view: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ])
    },
    ["user"]: {
        login: new Set([
            "*"
        ]),
        view: {
            guest: new Set([
                "id",
                "firstName",
                "lastName",
                "phone",
                "account"
            ]),
            publicUser: new Set([
                "id",
                "firstName",
                "lastName",
                "phone",
                "account"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        update: new Set([
            "view_only",
            "member",
            "creator",
            "manager",
            "admin"
        ]),
        suspend: new Set([
            "admin",
            "manager"
        ]),
        list: new Set([
            "admin",
            "manager"
        ]),
        impersonate: new Set([
            "admin"
        ]),
        updateUserPermissions: new Set([
            "admin",
            "manager"
        ]),
        export: new Set([
            "admin",
            "manager"
        ])
    },
    ["userInvite"]: {
        accept: new Set([
            "*"
        ]),
        view: new Set([
            "*"
        ]),
        create: new Set([
            "manager",
            "admin"
        ]),
        delete: new Set([
            "manager",
            "admin"
        ]),
        bulkCreate: new Set([
            "admin"
        ])
    },
    ["publicUserInvite"]: {
        accept: new Set([
            "*"
        ]),
        view: new Set([
            "*"
        ])
    },
    ["issue"]: {
        view: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        create: new Set([
            "creator",
            "member",
            "manager"
        ])
    },
    ["mailing"]: {
        create: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ])
    },
    ["paginationInfo"]: {
        view: new Set([
            "*"
        ])
    },
    ["warning"]: {
        view: new Set([
            "*"
        ]),
        update: new Set([
            "admin",
            "manager",
            "member"
        ])
    },
    ["mobileVersion"]: {
        view: new Set([
            "*"
        ])
    },
    ["userDevice"]: {
        view: new Set([
            ...UserRoleNames,
            "admin"
        ]),
        create: new Set(UserRoleNames),
        update: new Set(UserRoleNames)
    },
    ["userDeviceLocation"]: {
        view: new Set([
            ...UserRoleNames,
            "admin"
        ]),
        create: new Set(UserRoleNames),
        list: new Set([
            "admin",
            "manager"
        ])
    },
    ["queryDescription"]: {
        export: INTERNAL_ROLES_SET,
        store: CREATOR_AND_UP_SET
    },
    ["aiAction"]: {
        run: CREATOR_AND_UP_SET,
        view: INTERNAL_ROLES_SET,
        list: INTERNAL_ROLES_SET
    },
    ["aiActionRun"]: {
        view: CREATOR_AND_UP_SET
    },
    ["aiFeedback"]: {
        create: CREATOR_AND_UP_SET
    },
    ["apiKey"]: {
        view: INTERNAL_ROLES_SET,
        list: new Set([
            "admin"
        ]),
        create: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ])
    },
    ["workflowDefinition"]: {
        view: new Set([
            "*"
        ])
    },
    ["workflow"]: {
        view: new Set([
            ...INTERNAL_ROLES,
            "publicUser"
        ]),
        initiate: INTERNAL_ROLES_SET,
        share: CREATOR_AND_UP_SET,
        update: CREATOR_AND_UP_SET,
        delete: COMMON_DELETE_ROLES_SET
    },
    ["workflowStep"]: {
        view: INTERNAL_ROLES_SET,
        create: CREATOR_AND_UP_SET
    }
};
const AllowedPermissionsForResourcesThatRequirePII = {
    // we use an allowed list here, so that any *new* permission
    // added to sensitive PII resources are defaulted to requiring
    // PII access. So, for instance, all non-job rep loss permissions require PII access,
    // since the "allowed list" is empty
    ["repetitiveLoss"]: new Set([
        "view_settings"
    ]),
    ["repetitiveLossImportJob"]: new Set([
        "list"
    ])
};
const ResourcesThatRequirePIIPerEnvironment = {
    staging: _object_spread_props(_object_spread({}, AllowedPermissionsForResourcesThatRequirePII), {
        // in staging, neither of these resources require PII access,
        // so we give them *no* list as opposed to an empty list
        // to indicate they aren't under PII restrictions
        ["repetitiveLoss"]: undefined,
        ["repetitiveLossImportJob"]: undefined
    }),
    test: AllowedPermissionsForResourcesThatRequirePII,
    production: AllowedPermissionsForResourcesThatRequirePII,
    development: AllowedPermissionsForResourcesThatRequirePII
};
const resourcePermissionRequiresPII = ({ resource, permission, environment })=>{
    const allowedPermissionsForResourceThatRequiresPII = ResourcesThatRequirePIIPerEnvironment[environment][resource];
    return allowedPermissionsForResourceThatRequiresPII && !allowedPermissionsForResourceThatRequiresPII.has(permission);
};

//# sourceMappingURL=data:application/json;base64,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